// The assistant's first message in a new chat and its suggestion chips. The chat worker stores it as the chat's first
// message; the widget shows the same text at once while that chat is being created, so nobody waits for a fixed
// message. Both read it from here so the two never differ.

export const WELCOME = {
  website:
    'Hi! I’m CallSync’s AI assistant. Ask me anything about CallSync: what it does, pricing, setting up phones or recordings. If you need our team, I can raise a ticket for you.',
  dashboard: (first: string) =>
    `Hi${first ? ' ' + first : ''}! I’m CallSync’s AI assistant. Ask me about CallSync or your workspace and I’ll guide you step by step. If something needs our team, I’ll raise a ticket for you.`,
};

/** The chips under the welcome: a website visitor's, a workspace owner's (its creator) and a team member's. */
export const WELCOME_SUGGESTIONS = {
  website: ['What does CallSync do?', 'How much does it cost?', 'How do I set it up?'],
  owner: ['How many calls today?', 'Are all phones connected?', 'How do I add a team member?'],
  member: ['How do I connect a phone?', 'How do recordings work?', 'Where do I see my calls?'],
};

/** The first name the dashboard welcome uses, from the sign-in's full name (letters, apostrophes and hyphens). */
export function welcomeName(full: unknown): string {
  const name = typeof full === 'string' ? full.replace(/[\u0000-\u0009\u000b-\u001f\u007f]/g, '').trim().slice(0, 80) : '';
  return (name.split(/\s+/)[0] ?? '').replace(/[^\p{L}'-]/gu, '').slice(0, 30);
}
